import { createAsyncAction, createAction } from 'typesafe-actions';
import { AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { webApiGet, webApiPost } from '../../api/client'
import { Delivery, OrderResolverResult } from '../../api/models/QuotedData';
import { PaymentIntentData, HistoricalOrder, CreateOrderModel } from '../../api/models/OrderData';



export const createOrderAsync = createAsyncAction(
    "CREATE_ORDER_REQUEST",
    "CREATE_ORDER_SUCCESS",
    "CREATE_ORDER_ERROR")<undefined, number, Error>()

export const createOrderAsyncThunk = (orderData: CreateOrderModel ): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        return new Promise<void>((resolve) => {
            dispatch(createOrderAsync.request())
            return webApiPost('/order',
                orderData,//{ items: orderItems,  orderSheetId: orderSheetId },
                (data: number) => { dispatch(createOrderAsync.success(data)); resolve() },
                (err: Error) => { dispatch(createOrderAsync.failure(err)); },
            )
        })
    }
}


export const quoteOrderAsync = createAsyncAction(
    "QUOTE_ORDER_REQUEST",
    "QUOTE_ORDER_SUCCESS",
    "QUOTE_ORDER_ERROR")<undefined, OrderResolverResult, Error>()


export const quoteOrderAsyncThunk = (orderId: string): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        return new Promise<void>((resolve) => {
            dispatch(quoteOrderAsync.request())
            webApiGet('/order/' + orderId + '/quote',
                (data: OrderResolverResult) => { dispatch(quoteOrderAsync.success(data)); resolve() },
                (err: Error) => { dispatch(quoteOrderAsync.failure(err)); resolve() },
                null,
                3
            )
        })
    }
}


export const createOrderAndQuoteItThunk = (orderData: CreateOrderModel): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: any) => {
        return dispatch(createOrderAsyncThunk(orderData)).then(() => {
            const createdOrderId = getState().orderRdc.currentOrderId
            if (createdOrderId)
                return dispatch(quoteOrderAsyncThunk(createdOrderId!.toString()))
            else
                console.log("Order was not created!")
        }).catch(e => {
            console.log(e)
        })
    }
}


export const getHistoricalOrdersAsync = createAsyncAction(
    "GET_HISTORICAL_ORDERS_REQUEST",
    "GET_HISTORICAL_ORDERS_SUCCESS",
    "GET_HISTORICAL_ORDERS_ERROR")<undefined, HistoricalOrder[], Error>()


export const getHistoricalOrdersAsyncThunk = (): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        return new Promise<void>((resolve) => {
            dispatch(getHistoricalOrdersAsync.request())
            webApiGet('/order/history',
                (data: HistoricalOrder[]) => { dispatch(getHistoricalOrdersAsync.success(data)); resolve() },
                (err: Error) => { dispatch(getHistoricalOrdersAsync.failure(err)); resolve() },
                null,
                3
            )
        })
    }
}


export const getPaymentIntentAsync = createAsyncAction(
    "GET_PAYMENT_INTENT_REQUEST",
    "GET_PAYMENT_INTENT_SUCCESS",
    "GET_PAYMENT_INTENT_ERROR")<undefined, PaymentIntentData, Error>()


export const getPaymentIntentAsyncThunk = (orderID: number): ThunkAction<Promise<void>, {}, {}, AnyAction> => {
    return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
        return new Promise<void>((resolve) => {
            dispatch(getPaymentIntentAsync.request())
            webApiGet(`/order/${orderID}/paymentintent`,
                (data: PaymentIntentData) => { dispatch(getPaymentIntentAsync.success(data)); resolve() },
                (err: Error) => { dispatch(getPaymentIntentAsync.failure(err)); resolve() },
                null,
                3
            )
        })
    }
}


export const resetOrder = createAction('RESET_ORDER')()